import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import product4 from "../assets/products/product4.png";

const returnReasons = [
  "Received same product, but different color",
  "Received same product, but different size",
  "Received a completely different product",
  "Delivery was delayed",
  "Found a better price elsewhere",
  "I do not need it anymore",
  "Size too small",
  "Size too big",
  "I did not like the fit",
  "Received a poor quality product",
];

const ReturnProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { product, subProduct, order } = location.state || {};

  const [selectedReason, setSelectedReason] = useState("");
  const [confirmReturn, setConfirmReturn] = useState(false);

  return (
    <div className="max-w-6xl mx-auto px-4 py-6 text-gray-800">
      {/* Header */}
      <div className="flex items-center gap-3 mb-5">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full bg-white shadow hover:bg-purple-100 hover:text-purple-700 transition"
        >
          <ArrowLeft size={20} />
        </button>
        <h1 className="text-lg font-extrabold">Return Detail</h1>
      </div>

      {/* Product Info Card */}
      <div className="flex items-center gap-4 p-4 bg-gray-100 rounded-lg shadow-sm">
        <img
          loading="lazy"
          src={subProduct?.sub_pro_img ?? product4}
          alt="Product"
          className="w-22 h-28 rounded-md object-cover"
        />
        <div>
          <h2 className="font-semibold">{product?.product_name}</h2>
          <p className="text-sm text-gray-600">{product?.category_name}</p>
          <p className="text-sm text-gray-600">Color : {subProduct?.color}</p>
          <p className="text-sm text-gray-600">Size: {subProduct?.size}</p>
          <p className="font-semibold text-black mt-1">
            {subProduct?.customer_product_price} ₹
          </p>
        </div>
      </div>

      {/* Eligibility Notice */}
      <div className="flex items-center justify-between bg-green-50 border border-green-300 rounded-md p-3 mt-4 text-sm">
        <div className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="45"
            viewBox="0 0 44 45"
            fill="none"
          >
            <rect
              x="1.7049"
              y="1.7674"
              width="41.4537"
              height="41.4537"
              rx="20.7269"
              fill="#EBEBEB"
            />
            <rect
              x="1.7049"
              y="1.7674"
              width="41.4537"
              height="41.4537"
              rx="20.7269"
              stroke="#028D25"
              stroke-width="1.5902"
            />
            <mask
              id="mask0_1395_16825"
              maskUnits="userSpaceOnUse"
              x="9"
              y="9"
              width="26"
              height="27"
            >
              <rect
                x="9.67383"
                y="9.73828"
                width="25.2655"
                height="25.2655"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_1395_16825)">
              <path
                d="M22.3105 27.8497L14.9414 20.4806V25.2968H12.8359V16.875H21.2578V18.9805H16.4152L22.3105 24.8757L30.3112 16.875L31.7851 18.3751L22.3105 27.8497Z"
                fill="#028D25"
              />
            </g>
          </svg>
          <span className=" font-medium">
            Eligibility For exchange till 17 May
          </span>
        </div>
        <Link
          to="/return-and-refund-policy"
          className="text-pink-600 text-base font-semibold"
        >
          VIEW POLICY
        </Link>
      </div>

      {/* Return Reason Section */}
      <div className="bg-white mt-6 text-center">
        <h3 className="text-lg font-bold mb-1">
          Do you want to return? <span className="text-xl">😟</span>
        </h3>
        <p className="text-sm text-gray-500 mb-4">
          Don't worry we are here help you !<br />
          <span className="italic text-gray-400">-Select return reason-</span>
        </p>
      </div>

      {/* Reason Selection List */}
      <div className="bg-gray-100 p-5 rounded-lg mb-5">
        {returnReasons.map((reason, index) => (
          <label key={index} className="block mb-3 cursor-pointer">
            <input
              type="radio"
              name="returnReason"
              value={reason}
              checked={selectedReason === reason}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="mr-2"
            />
            {reason}
          </label>
        ))}
      </div>

      {/* Confirmation Checkbox */}
      <div className="bg-gray-100 p-4 rounded-md mb-5">
        <label className="flex items-center text-sm">
          <input
            type="checkbox"
            checked={confirmReturn}
            onChange={(e) => setConfirmReturn(e.target.checked)}
            className="mr-2"
          />
          Please confirm whether you want to return this product
        </label>
      </div>

      {/* Submit Button */}
      <button
        disabled={!selectedReason || !confirmReturn}
        className={`w-full py-3 rounded-md text-white font-bold transition ${
          !selectedReason || !confirmReturn
            ? "bg-[#FAD2D2] font-medium cursor-not-allowed"
            : "position: relative bg-[#bb7070] hover:bg-[#a65c5c]"
        }`}
      >
        RETURN PRODUCT
      </button>
    </div>
  );
};

export default ReturnProduct;
